<template>
  <div class="grid grid-cols-1 lg:grid-cols-detail m-4 md:mx-8 md:mt-16 gap-8">
    <section class="w-full rounded">
      <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
        <h2>{{ $t("lang.msg.factoryData") }}</h2>
      </div>
      <form class="bg-white p-4 space-y-4 rounded-b">
        <InputWrapper :label="$t('lang.fields.name')" content="input" block>
          <InputText v-model="newItem.factoryName" :name="$t('lang.fields.name')" font-semibold />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.substructures')" content="input" block>
          <multiselect
            v-model="newItem.substructures"
            :options="substructures"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :taggable="true"
            tag-placeholder="Escriba para añadir una subestructura"
            placeholder="Escriba para buscar subestructuras"
            label="subName"
            track-by="idSubStructure"
            select-label="Pulse enter para seleccionar"
            deselect-label="Pulse enter para eliminar"
            @select="storeSubstructure"
            @remove="removeSubstructure"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.ubication')" content="input" block>
          <InputText v-model="newItem.factoryLocation" :name="$t('lang.msg.ubication')" />
        </InputWrapper>
        <div class="flex space-x-4">
          <InputWrapper :label="$t('lang.fields.cif')" content="input" block>
            <InputText v-model="newItem.cif" :name="$t('lang.fields.cif')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
            <InputText v-model="newItem.phone" :name="$t('lang.fields.phone')" />
          </InputWrapper>
        </div>
        <InputWrapper :label="$t('lang.fields.email')" content="input" block>
          <InputText v-model="newItem.mail" type="email" :name="$t('lang.fields.email')" />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.agent')" content="input" block>
          <Select
            id="idFactoryAgent"
            :data="factoryAgents"
            track-by="factoryAgentName"
            v-model.number="newItem.idFactoryAgent"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.paymentMethod')" content="input" block>
          <Select
            id="idFormaPago"
            :data="paymentMethods"
            :track-by="getLangLabel('pagoNombre')"
            v-model.number="newItem.idFormaPago"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.fields.address')" content="input" block>
          <textarea
            class="form-textarea w-full"
            v-model="newItem.factoryAdress"
            :placeholder="$t('lang.fields.address')"
          />
        </InputWrapper>
        <InputWrapper :label="$t('lang.fields.anotations')" content="input" block>
          <textarea
            class="form-textarea w-full"
            v-model="newItem.anotations"
            :placeholder="$t('lang.fields.anotations')"
          />
        </InputWrapper>
        <AdminToggleButton v-model="newItem.active" />

        <span class="flex w-full rounded-md shadow-sm sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-primario hover:bg-primario text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Factories/Add`, `api/Factories/Update`, () => {})"
          >{{ newItem.idFactory == undefined ? $t('lang.msg.save') : $t('lang.msg.update') }}</button>
        </span>
      </form>
    </section>

    <div class="flex flex-col w-full space-y-8" v-if="newItem.idFactory">
      <section>
        <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
          <h2>{{ $t("lang.msg.contactPersons") }}</h2>
        </div>
        <div class="bg-white px-4 pb-2 rounded-b">
          <div
            v-for="(item, index) in contacts"
            :key="`item_${index}`"
            class="py-2 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-contacts gap-2 items-end"
          >
            <InputWrapper :label="$t('lang.fields.name')" content="input" block>
              <InputText v-model="item.contactName" :name="$t('lang.fields.name')" />
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.email')" content="input" block>
              <InputText v-model="item.email" :name="$t('lang.fields.email')" />
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.phone')" content="input" block>
              <InputText v-model="item.phone" :name="$t('lang.fields.phone')" />
            </InputWrapper>
            <InputWrapper :label="$t('lang.fields.charge')" content="input" block>
              <InputText v-model="item.cargo" :name="$t('lang.fields.charge')" />
            </InputWrapper>
            <div class="flex justify-between">
              <div class="flex space-x-2">
                <div class="flex space-x-2" v-if="contacts.length > 1 && item.idContactPerson">
                  <ButtonRounded @action="removeContact(index)" color="red">
                    <IconRemove />
                  </ButtonRounded>

                  <ButtonRounded @action="updateContact(item)" color="green">
                    <IconUpdate />
                  </ButtonRounded>
                </div>
                <ButtonRounded v-if="index == contacts.length - 1" @action="addNewContact(item)" color="blue">
                  <IconAdd />
                </ButtonRounded>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
          <h2>{{ $t("lang.msg.processes") }}</h2>
        </div>
        <div class="bg-white p-4 rounded-b">
          <multiselect
            v-model="newItem.processes"
            :options="processes"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :taggable="true"
            tag-placeholder="Escriba para añadir un proceso"
            placeholder="Escriba para buscar procesos"
            :label="getLangLabel('processName')"
            track-by="idProcess"
            select-label="Pulse enter para seleccionar"
            deselect-label="Pulse enter para eliminar"
            @select="processSelected"
            @remove="processRemoved"
          >
            <template slot="noOptions">
              La lista de procesos está vacia.
            </template>
          </multiselect>
        </div>
      </section>
      <section>
        <div class="px-4 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
          <h2>{{ $t("lang.msg.documents") }}</h2>
        </div>
        <div class="bg-white">
          <vue-dropzone
            ref="dropzone"
            id="dropzone"
            :options="dropzoneOptions"
            @vdropzone-sending="sendingEvent"
          />

          <div class="gallery">
            <ImageGallery
              v-for="(image, imageIndex) in images"
              :key="`image_${imageIndex}`"
              :url="image.url"
              :id-foto="image.idDocumentFactory"
              :delete="'factory'"
              @image-deleted="imageDeleted"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import UtilsMixin from "@/components/mixins/UtilsMixin";
import AdminMixin from "@/components/mixins/AdminMixin";

// DROPZONE
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Multiselect from "vue-multiselect";

export default {
  name: "FactoryDetail",
  mixins: [UtilsMixin, AdminMixin],
  components: {
    vueDropzone: vue2Dropzone,
    Multiselect
  },
  data() {
    return {
      idFactory: 0,
      params: {},
      substructures: [],
      processes: [],
      contacts: [],
      images: [],
      factoryAgents: [],
      paymentMethods: [],
      dropzoneOptions: {
        timeout: 120000,
        maxFilesize: 2048,
        url: `${this.$API_URL}/api/DocumentFactories/Add`,
        thumbnailWidth: 175,
        thumbnailHeight: 175,
        paramName: "files"
      }
    }
  },
  created() {
    if (this.$route.params.idFactory) {
      this.idFactory = parseInt(this.$route.params.idFactory);
      this.isEditing = true;

      // Set params to fetch the initial data.
      this.params = { idFactory: this.idFactory };
      this.fetchOneFactory();
    }

    this.fetchAgents();
    this.fetchAllProcesses();
    this.fetchComboSubstructures();
  },
  methods: {
    fetchOneFactory() {
      this.$axios.post("api/Factories/PostAllRSC", this.params).then((response) => {
        this.newItem = response.data[0] || {};

        this.fetchFactorySubstructures();
        this.fetchFactoryContacts();
        this.fetchFactoryProcesses();
        this.fetchDocuments();
        this.fetchPaymentMethods();
      });
    },
    fetchFactorySubstructures() {
      this.$axios.post("api/Factories/GetAllSubStructure", this.params).then((response) => {
        this.$set(this.newItem, 'substructures', response.data);
      });
    },
    fetchFactoryContacts() {
      this.$axios.post("api/ContactPersons/PostSearchFactory", this.params).then((response) => {
        // At least 1 contact exist in the array.
        response.data.push({});

        this.contacts = response.data;
      });
    },
    fetchFactoryProcesses() {
      this.$axios.post("api/Factories/SearchProcess", this.params).then((response) => {
        this.$set(this.newItem, 'processes', response.data);
      });
    },
    fetchDocuments() {
      this.$axios.post(`api/DocumentFactories/PostDocument`, this.params).then( response => {
        this.images = response.data;
      });
    },
    fetchAllProcesses() {
      this.$axios.get("api/Processes/GetProcessActive").then((response) => {
        this.processes = response.data;
      });
    },
    fetchComboSubstructures() {
      this.$axios.get("api/DocumentCertificats/ComboSubStructure").then((response) => {
        this.substructures = response.data;
      });
    },
    fetchPaymentMethods() {
      this.$axios.get(`api/FormaPagoes/GetAll`).then((response) => {
        this.paymentMethods = this.getActive(response.data, 'active');
      });
    },
    fetchAgents() {
      this.$axios.get(`api/FactoryAgents/GetFactoryAgent`).then((response) => {
        this.factoryAgents = this.getActive(response.data, 'active');
      });
    },
    contactIsValid(contact) {
      return contact.contactName && contact.email && contact.phone && contact.cargo;
    },
    addNewContact(contact) {
      if (this.contactIsValid(contact)) {
        // Append the idFactory to the contact.
        contact.idFactory = this.idFactory

        this.$axios.post(`api/ContactPersons/Add`, contact).then(() => {
          this.openAlert('success', 'Contacto añadido con éxito', null);
          this.fetchFactoryContacts(this.params);
          this.contacts.push({});
        });
      } else {
        this.openAlert('info', 'Rellene correctamente el formulario', null);
      }
    },
    updateContact(contact) {
      this.$axios.post(`api/ContactPersons/Update`, contact).then(() => {
        this.openAlert('success', 'Contacto actualizado', null);
      });
    },
    removeContact(index) {
      let contact = this.contacts[index];

      this.$axios.post(`api/ContactPersons/Delete`, contact).then(() => {
        this.openAlert('success', 'Contacto eliminado', null);
      });

      this.contacts.splice(index, 1);
    },
    processSelected(item) {
      // Append the idFactory to the process.
      item.idFactory = this.idFactory;

      this.$axios.post(`api/Factories/AddProcessFactory`, item).then(() => {
        this.fetchFactoryProcesses(this.params);
        this.openAlert('success', 'Proceso añadido', null);
      });
    },
    processRemoved(event) {
      this.$axios.post(`api/Factories/DeleteProcessFactory`, {
        idProcessFactory: event.idProcessFactory
      }).then(() => {
        this.openAlert('success', 'Proceso eliminado', null);
      });
    },
    storeSubstructure(item) {
      this.$axios.post(`api/Factories/AnadirSubStructura`, {
        idSubStructure: item.idSubStructure,
        idFactory: this.idFactory
      }).then(() => {
        this.fetchFactorySubstructures();
      });
    },
    removeSubstructure(item) {
      this.$axios.post(`api/Factories/DeleteSubStructura`, item);
    },
    sendingEvent(file, xhr, formData) {
      formData.append("idFactory", this.newItem.idFactory);
    },
    imageDeleted(idFoto) {
      let images = this.images.filter(image => {
        return image.idFoto != idFoto
      });

      this.images = images;
      this.$forceUpdate();
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
